import React from 'react';
import {observer} from "mobx-react";
import {HelperDate} from "../../helper/HelperDate";


interface Props {
    arUsers: [],
    onHandlerClick: (id: number) => void,
    onFilterUser: (e: any) => void
    setShowNextStep: any
    showNextStep: boolean
    activeId: any
    userEmail: string
    changeUserEmail: any
    deleteUser: any
    updateUser: any
    sendEmailReplay: any
}


@observer
export class EmailReplay extends React.Component<Props, {}> {

    render() {
        const {arUsers} = this.props;
        const {
            onFilterUser,
            setShowNextStep,
            showNextStep,
            activeId,
            userEmail,
            changeUserEmail,
            deleteUser,
            updateUser,
            sendEmailReplay
        } = this.props;



        return (<>
            <div className="subtitle">
                <div className="subtitle-text">
                    <span className="subtitle__text">Повторная отправка:</span>
                </div>

                <div className="subtitle-nav">
                    <div className="search-on-page">

                        <div className="search-form-on-page-wrapper">
                            <input id="search-on-page-input" onChange={(e) => onFilterUser(e)}
                                   className="search-on-page__text" type="text"
                                   placeholder="Поиск  по всем столбцам"/>
                            <img className="search-on-page__ico" alt="search_ico.svg"
                                 src="/img/ico/personal/Search.svg"/>
                        </div>

                    </div>

                </div>
            </div>

            <div className="user-list-topline no-space-between">
                <div className="td2-1">
                    <div className="td2-1-text">

                    </div>
                    <div className="">
                        <span className="basket-item-top-line__text">Логин / Повторная отправка подтверждения</span>
                    </div>

                </div>
                <div className="td2-2">
                    <span className="basket-item-top-line__text">ФИО</span>
                </div>
                <div className="td2-3" style={{width: 100}}>
                    <span className="basket-item-top-line__text">Должность</span>
                </div>
                <div className="td2-4">
                    <span className="basket-item-top-line__text">Тип</span>
                </div>
                <div className="td2-5">
                    <span className="basket-item-top-line__text">Организация</span>
                </div>
                <div className="td2-6"  style={{margin: "auto"}} >
                    <span className="basket-item-top-line__text" style={{width: 250}}>Действия</span>
                </div>
                <div className="td2-7" style={{margin: "auto"}} >
                    <span className="basket-item-top-line__text" style={{width: 150, }}>Дата последнего изменения</span>
                </div>
            </div>
            <div className="user-list">
                {arUsers.length ? arUsers.map((user: any ,index: number) => (
                        <>
                            <div key={'user-' + user.id} className={"user-list-item"}>
                                <div className="td2-1 list-item-border">
                                    <div className="td2-1-text">
                                    </div>
                                    <div className="td2-1-text cursor" >
                                        {user.id===activeId ? <input type="text" name="input"
                                                                     value={user.id===activeId ? userEmail : user.email}
                                                                     onChange={(e)=> changeUserEmail(e.target.value)}
                                                                     disabled={user.id!==activeId}/>:
                                            <span className="list-item-text__normal-lightblue" onClick={()=> sendEmailReplay(user.id)}>{user.email}</span>}


                                    </div>
                                </div>
                                <div className="td2-2 list-item-border" >
                                    <div className="client-mobile-title">ФИО</div>
                                    <span
                                        className="list-item-text__normal"  style={{padding: 10}} >
                                        {user.lastName} {user.firstName} {user.secondName}
                                    </span>
                                </div>
                                <div className="td2-3 list-item-border" style={{width: 100}}>
                                    <div className="client-mobile-title">Должность</div>
                                    <span
                                        className="list-item-text__normal">{user.post}</span>
                                </div>
                                <div className="td2-4 list-item-border">
                                    <div className="client-mobile-title">Тип</div>
                                    <span className="list-item-text__normal">{user.type}</span>
                                </div>
                                <div className="td2-5 list-item-border">
                                    <div className="client-mobile-title">Организация</div>
                                    <span className="list-item-text__normal">{user.fullNameOrg}</span>
                                </div>
                                <div className="td2-6 list-item-border" style={{width: 250}}>
                                    <div className="client-mobile-title">Действия</div>
                                    {user.active ? <span
                                            className="list-item-text__normal user-list-item-user-status-active">Активный</span> :
                                        <>
                                           <span
                                               className="list-item-text__normal user-list-item-user-status-block">
                                               <button
                                               onClick={() => setShowNextStep(!showNextStep, user.id, user.email)}>
                                               Заблокирован {showNextStep ? <>&#9998;</> : <>&#10000;</>}
                                               </button>
                                           </span>
                                            {showNextStep && user.id===activeId  ? <>
                                                <div style={{display: "block"}}>
                                                    <button onClick={()=> updateUser()}
                                                            style={{
                                                                background: "#ddfdf3",
                                                                width: 150,
                                                                margin:5}}
                                                    >сохранить email &#10004;</button>
                                                    <button onClick={()=> deleteUser()}
                                                            style={{
                                                                background: "#fce1ea",
                                                                width: 150,
                                                                margin:5}}
                                                    >удалить юзера &#10060;</button>
                                                </div>

                                            </>: null

                                            }
                                        </>
                                    }
                                </div>
                                <div className="td2-7 list-item-border" style={{width: 150}}>
                                    <div className="client-mobile-title">Дата последнего изменения</div>
                                    <div className="td2-7-padding">
                                        <span
                                            className="list-item-text__normal">{HelperDate.getDate(user.updatedAt)}</span>
                                    </div>
                                    <div>
                                        <span
                                            className="list-item-text__normal">{HelperDate.getTime(user.updatedAt)}</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))
                    : (<p className="search-on-page__text"> список пуст</p>)}
            </div>

        </>);
    }
}
